import { TokenPayload } from './parseAuthData';
import { setAccessToken } from './accessToken';
import { setRefreshToken } from './refreshToken';
import { setExpiryTime } from './expiryTime';

const setAuthData = ({ accessToken, refreshToken, expiryTime }: TokenPayload) => {
  setAccessToken(accessToken);
  setRefreshToken(refreshToken);
  setExpiryTime(expiryTime);
};

export default setAuthData;
